/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS202: Simplify dynamic range loops
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import _ from 'underscore';

// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { ModelLoader } from 'app/scripts/db/model-loader';
import { ModelCache } from 'app/scripts/db/ModelCache';
import { l } from 'app/scripts/lib/localize';
import Payloads from 'app/scripts/network/payloads';

// eslint-disable-next-line @trello/enforce-variable-case
const SelectCardPosition = {
  renderValues() {
    // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
    const idBoard = $('.js-select-board option:selected', this.$el).val();
    // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
    const idList = $('.js-select-list option:selected', this.$el).val();
    let pos =
      parseInt(
        // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
        $('.js-select-position option:selected', this.$el).prop('index'),
        10,
      ) + 1;

    // @ts-expect-error
    const board = ModelCache.get('Board', idBoard);
    // @ts-expect-error
    const boardName = board.get('name');
    // @ts-expect-error
    const list = _.find(board.listList.models, ({ id }) => id === idList);

    // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
    $('.js-board-value', this.$el).text(boardName);

    // It's possible that the board has no open lists, in which case we need to disable
    // some of the controls
    if (list != null) {
      // @ts-expect-error TS(2339): Property 'get' does not exist on type '{ id: any; ... Remove this comment to see the full error message
      const listName = list.get('name');
      // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'number'.
      pos = pos.toString();

      // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
      $('.js-list-value', this.$el).text(listName);
      // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
      $('.js-pos-value', this.$el).text(pos);

      $(
        '.js-select-list,.js-select-position,.js-commit-position,.js-submit',
        // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
        this.$el,
      ).prop('disabled', false);
    } else {
      // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
      $('.js-list-value', this.$el)
        .empty()
        .append($('<i></i>').text(l('no lists')));
      // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
      $('.js-pos-value', this.$el)
        .empty()
        .append($('<i></i>').text(l('n/a')));

      $(
        '.js-select-list,.js-select-position,.js-commit-position,.js-submit',
        // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
        this.$el,
      ).attr('disabled', 'disabled');
    }
  },

  updateBoardData() {
    // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
    // eslint-disable-next-line @trello/enforce-variable-case
    const $selectBoard = $('.js-select-board', this.$el);
    const idBoardSelected = $selectBoard.find('option:selected').val();

    // @ts-expect-error TS(2339): Property 'model' does not exist on type '{ renderV... Remove this comment to see the full error message
    if (idBoardSelected === this.model.getBoard().id) {
      // @ts-expect-error TS(2339): Property '_boardData' does not exist on type '{ re... Remove this comment to see the full error message
      this._boardData = this.model.getBoard();
      // @ts-expect-error TS(2339): Property '_boardData' does not exist on type '{ re... Remove this comment to see the full error message
      for (const list of Array.from(this._boardData.listList.models)) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        list.cardCount = this._boardData.listList
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          .get(list.id)
          .openCards().length;
      }
      SelectCardPosition.updateListList.call(this);
    } else if (idBoardSelected != null) {
      // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
      $('.js-submit', this.$el).attr('disabled', 'disabled');
      // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
      ModelLoader.loadBoardData(idBoardSelected, Payloads.cardsAndListsMinimal)
        .then(() => {
          // @ts-expect-error TS(2339): Property '_boardData' does not exist on type '{ re... Remove this comment to see the full error message
          this._boardData = ModelCache.get('Board', idBoardSelected);
          // updateListList also updates position and rerenders the view
          return SelectCardPosition.updateListList.call(this);
        })
        .done();
    }
  },

  updateListList() {
    let idListSelected;
    // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
    // eslint-disable-next-line @trello/enforce-variable-case
    const $selectBoard = $('.js-select-board', this.$el);
    // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
    // eslint-disable-next-line @trello/enforce-variable-case
    const $selectList = $('.js-select-list', this.$el).empty();

    const idBoardSelected = $selectBoard.find('option:selected').val();

    // @ts-expect-error TS(2339): Property 'model' does not exist on type '{ renderV... Remove this comment to see the full error message
    const idListCurrent = this.model.getList().id;
    // @ts-expect-error TS(2339): Property 'model' does not exist on type '{ renderV... Remove this comment to see the full error message
    if (idBoardSelected === this.model.getBoard().id) {
      idListSelected = idListCurrent;
    } else {
      // @ts-expect-error TS(2339): Property '_boardData' does not exist on type '{ re... Remove this comment to see the full error message
      idListSelected = this._boardData.listList.at(0)?.id;
    }

    // @ts-expect-error TS(2339): Property '_boardData' does not exist on type '{ re... Remove this comment to see the full error message
    for (const list of Array.from(this._boardData.listList.models)) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      // eslint-disable-next-line @trello/enforce-variable-case
      const $option = $('<option>').val(list.id).appendTo($selectList);

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      list.id === idListCurrent
        ? // l is going to return HTML (e.g. it's going to escape things)
          // @ts-expect-error TS(2339): Property 'format' does not exist on type 'JQuery<H... Remove this comment to see the full error message
          $option.format('current list', { listName: list.get('name') })
        : // @ts-expect-error TS(2571): Object is of type 'unknown'.
          $option.text(list.get('name'));

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (list.id === idListSelected) {
        $option.attr('selected', 'selected');
      }
    }

    return this.updatePositionList();
  },

  updatePositionList() {
    let currentIndex, left, selectedIndex;
    // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
    // eslint-disable-next-line @trello/enforce-variable-case
    const $selectList = $('.js-select-list', this.$el);
    // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
    // eslint-disable-next-line @trello/enforce-variable-case
    const $selectPos = $('.js-select-position', this.$el).empty();
    const idListSelected = $selectList.find('option:selected').val();

    if (idListSelected == null) {
      this.renderValues();
      return;
    }

    const listSelected =
      // @ts-expect-error TS(2339): Property '_boardData' does not exist on type '{ re... Remove this comment to see the full error message
      (left = this._boardData.listList.get(idListSelected)) != null
        ? left
        : // @ts-expect-error TS(2339): Property '_boardData' does not exist on type '{ re... Remove this comment to see the full error message
          this._boardData.listList.at(0);

    const sameList =
      (listSelected != null ? listSelected.id : undefined) ===
      // @ts-expect-error TS(2339): Property 'model' does not exist on type '{ renderV... Remove this comment to see the full error message
      this.model.getList().id;
    // @ts-expect-error TS(2339): Property '_boardData' does not exist on type '{ re... Remove this comment to see the full error message
    let maxIndex = this._boardData.listList.get(idListSelected).cardList.length;

    if (sameList) {
      // @ts-expect-error TS(2339): Property 'model' does not exist on type '{ renderV... Remove this comment to see the full error message
      currentIndex = this.model.getList().openCards().indexOf(this.model);
      selectedIndex = currentIndex;
      // @ts-expect-error TS(2339): Property 'showCurrentPosition' does not exist on t... Remove this comment to see the full error message
      if (!this.showCurrentPosition) {
        // if we are copying the card, we should be able to move to any location still
        maxIndex -= 1;
      }
    } else {
      currentIndex = -1;
      selectedIndex = maxIndex;
    }

    for (
      let i = 0, end = maxIndex, asc = 0 <= end;
      asc ? i <= end : i >= end;
      asc ? i++ : i--
    ) {
      const indexString = String(i + 1);

      const desc =
        i === currentIndex
          ? l('current position', { index: indexString })
          : indexString;

      const pos =
        i === 0 ? 'top' : i === maxIndex ? 'bottom' : listSelected.calcPos(i);

      // eslint-disable-next-line @trello/enforce-variable-case
      const $option = $('<option>').val(pos).text(desc).appendTo($selectPos);

      if (i === selectedIndex) {
        $option.attr('selected', 'selected');
      }
    }

    // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ renderVal... Remove this comment to see the full error message
    $('.js-pos-value', this.$el).text(String(selectedIndex));

    this.renderValues();
  },
};

export { SelectCardPosition };
